import { render, staticRenderFns } from "./ObsStreamButton.vue?vue&type=template&id=3a69ae24&"
import script from "./ObsStreamButton.vue?vue&type=script&lang=js&"
export * from "./ObsStreamButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports